import React from "react";
import axios from "axios";

import "./PaymentSuccess.css";

export default class PaymentPage extends React.Component {
  constructor() {
    super();

    this.state = {
      orderId: null,
      status: null
    };
  }

  componentDidMount() {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/order/${
          this.props.match.params.orderHash
        }`
      )
      .then(res => {
        if (res.data.response.order_id) {
          this.setState({
            status: res.data.request.status,
            orderId: res.data.response.order_id,
            serviceName: res.data.response.service_name,
            serviceDesc: res.data.response.service_desc,
            serviceType: res.data.response.service_type,
            servicePrice: res.data.response.service_price
          });
        } else {
          window.location = "/";
        }
      })
      .catch(err => (window.location = "/"));
  }

  render() {
    return (
      <div className="content">
        {this.state.orderId && (
          <div>
            <h2>Спасибо за ваш заказ!</h2>
            <p>
              <span style={{ color: "#666666" }}>Номер вашего заказа:</span>{" "}
              {this.state.orderId}
            </p>
            <p>
              <span style={{ color: "#666666" }}>Статус вашего заказа:</span>{" "}
              {this.state.status}
            </p>
            <p style={{ paddingBottom: "0.5rem" }}>
              <span style={{ color: "#666666" }}>Содержимое:</span>
            </p>
            <div className="order-table">
              <div className="order-table__row">
                <div>Услуга</div>
                <div>Тип</div>
                <div>Стоимость</div>
              </div>
              <div className="order-table__row">
                <div>
                  <p>{this.state.serviceName}</p>
                  <p style={{ color: "#666" }}>{this.state.serviceDesc}</p>
                </div>
                <div>{this.state.serviceType}</div>
                <div>{this.state.servicePrice} ₽</div>
              </div>
            </div>
            <p style={{ marginTop: "2rem" }}>
              <a href="/" style={{ textDecoration: "underline" }}>
                Вернуться на главную
              </a>
            </p>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PaymentSuccess/PaymentSuccess.js